import { StyledLoadingSpinnerContainer } from './LoadingSpinner.styles';
import { Spinner } from './Spinner';

interface LoadingSpinnerProps {
  isLoading: boolean;
  [key: string]: any;
}

export const LoadingSpinner = ({ children, isLoading, ...rest }: LoadingSpinnerProps) => {
  return (
    <StyledLoadingSpinnerContainer {...rest}>
      {isLoading ? <Spinner paddingTop={50} /> : <>{children}</>}
    </StyledLoadingSpinnerContainer>
  );
};
